import type { ApiErrorBody } from "@/types/api";

export class ApiError extends Error {
  status: number;
  body: unknown;

  constructor(status: number, body: unknown, message?: string) {
    super(message || `Request failed with status ${status}`);
    this.name = "ApiError";
    this.status = status;
    this.body = body;
  }

  get userMessage(): string {
    if (!this.body || typeof this.body !== "object") {
      return this.message;
    }

    const body = this.body as ApiErrorBody;
    if (typeof body.error?.message === "string" && body.error.message.trim()) {
      return body.error.message;
    }
    if (typeof body.detail === "string" && body.detail.trim()) return body.detail;
    if (typeof body.message === "string" && body.message.trim()) return body.message;
    return this.message;
  }
}
